'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  // Options.jsx
  items_per_page: '/ páginas',
  jump_to: 'Vá até',
  page: '',

  // Pagination.jsx
  prev_page: 'Página anterior',
  next_page: 'Próxima página',
  prev_5: '5 páginas anteriores',
  next_5: '5 próximas páginas',
  prev_3: '3 páginas anteriores',
  next_3: '3 próximas páginas'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-pagination@1.8.7@rc-pagination/lib/locale/pt_BR.js
 ** module id = 840
 ** module chunks = 1
 **/